import { render, staticRenderFns } from "./debug2.vue?vue&type=template&id=99bc205e&scoped=true"
import script from "./debug2.vue?vue&type=script&lang=js"
export * from "./debug2.vue?vue&type=script&lang=js"
import style0 from "./debug2.vue?vue&type=style&index=0&id=99bc205e&prod&lang=scss&scoped=true"
import style1 from "./debug2.vue?vue&type=style&index=1&id=99bc205e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bc205e",
  null
  
)

export default component.exports